import router from './router'

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
      }else{
        document.title = '大医健康'
      }
      next();
})

router.afterEach(() => {})



// WEBPACK FOOTER //
// ./src/permission.js